module.exports = __webpack_public_path__ + "static/media/star.41ee1ff2.svg";